import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Card, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MissionControlTenant } from "src/store/api/generatedApi";
import { MissionControlTab } from "./TenantListPanel";
import { TenantRow } from "./TenantRow";

const MISSION_CONTROL_TABS: MissionControlTab[] = [
  "savings",
  "inventory",
  "schedule",
  "steelMix",
  "shredUsage",
];

const TAB_LABELS: Record<MissionControlTab, string> = {
  savings: "savings",
  inventory: "inventory",
  schedule: "SIOP",
  steelMix: "steelMix",
  shredUsage: "shredUsage",
};

export const GlassInfoPanel = ({
  tenant,
  activeTab,
  onTabChange,
  onClose,
}: {
  tenant: MissionControlTenant;
  activeTab: MissionControlTab;
  onTabChange: (tab: MissionControlTab) => void;
  onClose: () => void;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const tabIndex = Math.max(0, MISSION_CONTROL_TABS.indexOf(activeTab));
  const prevTab: MissionControlTab =
    MISSION_CONTROL_TABS[
      (tabIndex - 1 + MISSION_CONTROL_TABS.length) % MISSION_CONTROL_TABS.length
    ] ?? "savings";
  const nextTab: MissionControlTab =
    MISSION_CONTROL_TABS[(tabIndex + 1) % MISSION_CONTROL_TABS.length] ??
    "inventory";

  return (
    <Card
      sx={{
        background: "rgba(255,255,255,0.35)",
        backdropFilter: "saturate(180%) blur(18px)",
        WebkitBackdropFilter: "saturate(180%) blur(18px)",
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      <TenantRow tenant={tenant} activeTab={activeTab} onClose={onClose} />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={0.5}
        sx={{
          py: 0.5,
          px: 0.5,
        }}
      >
        <IconButton
          aria-label={t(TAB_LABELS[prevTab])}
          onClick={(e) => {
            e.stopPropagation();
            onTabChange(prevTab);
          }}
          size="small"
          sx={{ color: theme.palette.text.secondary }}
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ minWidth: 72, textAlign: "center" }}
        >
          {t(TAB_LABELS[activeTab])}
        </Typography>
        <IconButton
          aria-label={t(TAB_LABELS[nextTab])}
          onClick={(e) => {
            e.stopPropagation();
            onTabChange(nextTab);
          }}
          size="small"
          sx={{ color: theme.palette.text.secondary }}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Card>
  );
};
